<template>
  <div>
    <div>
      <b-button class="btn d-block p-2 bg-mdh text-white btn-secondary" size="sm" @click="download">Download history of influenza coverage</b-button>
    </div>
    <b-table hover small caption-top responsive boardered show-empty
             id="fluTable"
             :fields="fields"
             :items="files"
             :busy=isLoading
             sort-icon-left
             style="padding: 10px"
    >
      <div slot="table-busy" class="text-center text-danger my-2">
        <b-spinner class="align-middle" style="margin-right:5px; margin-top:12px;"></b-spinner>
        <strong>Loading, Please Wait...</strong>
      </div>
      <template v-slot:empty="scope">
        <p>No data found.</p>
      </template>
    </b-table>
    <br>
  </div>
</template>

<script>
import axios from "axios";
import * as xlsx from "xlsx"

export default {
  data: () => ({
    isLoading: false,
    files: [],
    fields: [{key: 'respiratorySeason', label: 'Season'},
      {key: 'numEmployeesFlu', label: 'Total employees vaccinated for flu'},
      {key: 'numEmployeesTotal', label: 'Total employees assessed'},
      {key: 'percentageFlu', label: 'Influenza vaccination coverage rate'},
      {key: 'changePercent', label: 'Change in coverage rate from previous season'},
    ],
  }),

  mounted() {
    this.$watch('this.$store.state.selectedFacility', function() {
      this.fetchFiles()
    })
  },

  computed: {
    selectedFacility() {
      return this.$store.state.selectedFacility
    }
  },

  watch: {
    selectedFacility() {
      this.fetchFiles()
    }
  },

  methods: {
    fetchFiles() {
      this.isLoading = true
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/respsafe/fluHistory/${this.$store.state.selectedFacility.id}`)
        .then((response) => {
          if (response.status === 200) {
            this.files = response.data
          }
          this.isLoading = false
        })
        .catch((err) => {
          console.log(err)
        })
      this.isLoading = false
    },
    async download() {
      const worksheet = xlsx.utils.json_to_sheet(this.files)

      for (let i = 65, j=0; i <= 72, j < 5; i++, j++) {
        // use label values for headers instead of key values
        const character = String.fromCharCode(i)
        const cellVal = `${character}1`
        let cell = worksheet[cellVal]
        cell.v = this.fields[j].label
      }

      worksheet['!cols'] = [
        {wch: 8},
        {wch: 28},
        {wch: 21},
        {wch: 29},
        {wch: 38},
      ];

      const workbook = xlsx.utils.book_new();
      xlsx.utils.book_append_sheet(workbook, worksheet, "Flu data");

      xlsx.writeFileXLSX(workbook, "Influenza_history.xlsx");
    }
  }
}

</script>

<style scoped>
.btn-sm {
  margin-top: 1em;
}
</style>
